<template>
	<div>
		<CHead :oHead="oHead"></CHead>
		<div class="row justify-content-center mt-3">
			<!-- <div class="col-12 col-sm-12 col-md-4 col-lg-4">
            </div> -->
			<div class="col-12 col-sm-12 col-md-6 col-lg-6">
				<div class="card card-01 p-0 pb-3">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<nav>
								<div class="nav nav-tabs nav-tabs-table" id="nav-tab" role="tablist">
									<a class="nav-item nav-link active" style="" id="general-tab" data-toggle="tab" href="#nav-general" role="tab" aria-controls="nav-general" aria-selected="true">General</a>
									<a class="nav-item nav-link" style="" id="carta-tab" data-toggle="tab" href="#nav-carta" role="tab" aria-controls="nav-carta" aria-selected="true">Carta Presentación</a>
									<a class="nav-item nav-link" style="" id="oficina-tab" data-toggle="tab" href="#nav-oficina" role="tab" aria-controls="nav-oficina" aria-selected="true">Nuestras Oficinas</a>
									<a class="nav-item nav-link" style="" id="terminos-tab" data-toggle="tab" href="#nav-terminos" role="tab" aria-controls="nav-terminos" aria-selected="true">Términos y Condiciones</a>
									<!-- <a v-for="(item,index) in ListaDistribuidor" :key="index" @click="CambiarDistro(index)" class="nav-item nav-link nav-pink" style="width:12%" :id="item.IdUsuario+'-tab-material'" data-toggle="tab" :href="'#nav-material-'+item.IdUsuario" role="tab" :aria-controls="'nav-material-'+item.IdUsuario" aria-selected="false">Almacén {{item.Usuario}}</a> -->
								</div>
							</nav>
							<CLoader :pConfigLoad="ConfigLoad">
								<template slot="BodyFormLoad">
									<div class="row p-2">
										<div class="col-12 col-sm-12 col-md-12 col-lg-12">
											<div class="tab-content tab-content-table">
												<div class="tab-pane fade show active" id="nav-general" role="tabpanel" aria-labelledby="general-tab">
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-4 col-lg-4">
															<label>Logo de la Empresa <small>(Recomendado 400x400)</small></label>
															<div class="avatar-upload">
																<div class="avatar-edit">
																	<input
																		id="file"
																		ref="file"
																		type="file"
																		name="myfile"
																		@change="uploadImage()"
																		accept=".png, .jpg, .jpeg"
																	/>
																	<label for="file"></label>
																</div>
																<div class="avatar-preview">
																	<div
																		id="imagePreview"
																		style="background-image: url(Img);"
																	></div>
																</div>
															</div>
														</div>
														<div class="col-12 col-sm-12 col-md-4 col-lg-4">
															<label for="">Color de títulos</label>
															<input type="color" v-model="OpcionPropuesta.ColorTextoTitulo" class="form-control form-control-sm"/>
															<br/>
															<label for="">Color de texto</label>
															<input type="color" v-model="OpcionPropuesta.ColorTexto" class="form-control form-control-sm"/>
															<br/>
															<label for="">Color de fondo</label>
															<input type="color" v-model="OpcionPropuesta.Color" class="form-control form-control-sm"/>
															<br/>
															<label for="">Impuesto</label>
															<select class="form-control" v-model="OpcionPropuesta.TipoImpuesto">
																<option value="">Selecciona una Opción</option>
																<option value="IVA">IVA</option>
																<option value="VAT">VAT</option>
																<option value="IGV">IGV</option>
																<option value="ITBMS">ITBMS</option>
																<option value="ITBIS">ITBIS</option>
																<option value="IPI">IPI</option>
																<option value="GST">GST</option>
															</select>
															<br>
															<label for="">Sitio Web</label>
															<input type="text" class="form-control" v-model="OpcionPropuesta.PaginaWeb">
														</div>
														<div class="col-12 col-sm-12 col-md-4 col-lg-4">
															<label for="">Fuente Títulos</label>
															<select class="form-control" v-model="OpcionPropuesta.FuenteTitulo">
																<option value="">Selecciona una Opción</option>
																<option style="font-family:Arial Black" value="arial_black">Arial Black</option>
																<option style="font-family:Roboto" value="robotocondensed">Roboto</option>
																<option style="font-family:Arial" value="arial">Arial</option>
															</select>
															<br>
															<label for="">Fuente Cuerpo</label>
															<select class="form-control" v-model="OpcionPropuesta.FuenteCuerpo">
																<option value="">Selecciona una Opción</option>
																<option style="font-family:Arial Black" value="arial_black">Arial Black</option>
																<option style="font-family:Roboto" value="robotocondensed">Roboto</option>
																<option style="font-family:Arial" value="arial">Arial</option>
															</select>
															<br>
															<label for="">Pie de Página</label>
															<textarea v-model="OpcionPropuesta.PiePagina" cols="30" rows="4" class="form-control"></textarea>
														</div>
													</div>
												</div>
												<div class="tab-pane fade" id="nav-carta" role="tabpanel" aria-labelledby="carta-tab">
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-12 col-lg-12">
															<label for="">Descripción</label>
															<textarea v-model="OpcionPropuesta.CartaPresentacion" cols="30" rows="10" class="form-control"></textarea>
														</div>
													</div>
												</div>
												<div class="tab-pane fade" id="nav-oficina" role="tabpanel" aria-labelledby="oficina-tab">
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-6 col-lg-6">
															<div class="avatar-upload">
																<div class="avatar-edit">
																	<input
																		id="fileoficina"
																		ref="fileoficina"
																		type="file"
																		name="myfileoficina"
																		@change="uploadImageOficina()"
																		accept=".png, .jpg, .jpeg"
																	/>
																	<label for="fileoficina"></label>
																</div>
																<div class="avatar-preview">
																	<div
																		id="imagePreviewOficina"
																		style="background-image: url(Img);"
																	></div>
																</div>
															</div>
														</div>
														<div class="col-12 col-sm-12 col-md-6 col-lg-6">
															<label for="">Descripción</label>
															<textarea v-model="OpcionPropuesta.DescripcionOficina" cols="30" rows="5" class="form-control"></textarea>
														</div>
													</div>
												</div>
												<div class="tab-pane fade" id="nav-terminos" role="tabpanel" aria-labelledby="terminos-tab">
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-12 col-lg-12">
															<label for="">Términos y Condiciones A</label>
															<textarea v-model="OpcionPropuesta.TerminosA" cols="30" rows="5" class="form-control"></textarea>
														</div>
													</div>
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-12 col-lg-12">
															<label for="">Términos y Condiciones B</label>
															<textarea v-model="OpcionPropuesta.TerminosB" cols="30" rows="5" class="form-control"></textarea>
														</div>
													</div>
													<div class="form-group form-row">
														<div class="col-12 col-sm-12 col-md-12 col-lg-12">
															<label for="">Términos y Condiciones C</label>
															<textarea v-model="OpcionPropuesta.TerminosC" cols="30" rows="5" class="form-control"></textarea>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</CLoader>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
							<button @click="Regresar" type="button" class="btn btn-04 ban mr-2">Cancelar</button>
                            <button :disabled="DisabledBtn" @click="Guardar" type="button" class="btn btn-01">Guardar</button>&nbsp;
						</div>
					</div>
				</div>
            </div>
		</div>
	</div>
</template>

<script>
import $$ from "jquery";
import Cbtnsave from '@/components/Cbtnsave.vue'
export default {
	name:'FormOpcionPropuesta',
	// props:['IdHorasL'],
	data() {
		return {
			Modal:true,//Sirve pra los botones de guardado
			FormName:'OpcionPropuesta',
			 ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			OpcionPropuesta:{
				IdOpcionPropuesta:0,
				Color:"#000000",
				ColorTexto:"#000000",
				ColorTextoTitulo:"#000000",
				TerminosA:"",
				TerminosB:"",
				TerminosC:"",
				Imagen:"",
				TipoImpuesto:"",
				FuenteTitulo:"",
				FuenteCuerpo:"",
				CartaPresentacion:"",
				ImagenOficina:"",
				DescripcionOficina:"",
				PiePagina:"",
				PaginaWeb:""
            },
			Img:null,
			ImgOficina:null,
			oHead:{//Encabezado
                Title:'Config. De Propuestas',
                BtnNewShow:false,
                BtnNewName:'Nuevo',
                isreturn:true,
                isModal:false,
                isEmit:false,
                Url:'submenucotizacion',
                ObjReturn:'',
            },
			DisabledBtn:false,
			RutaEmpresa:'',
			LogoEmpresa:''
		}
	},
	components:{
        Cbtnsave
    },
	methods: {
		async Guardar(){
			this.DisabledBtn=true;
			let formData=new FormData();
			formData.set('IdOpcionPropuesta',this.OpcionPropuesta.IdOpcionPropuesta);
			formData.set('Color',this.OpcionPropuesta.Color);
			formData.set('ColorTexto',this.OpcionPropuesta.ColorTexto);
			formData.set('ColorTextoTitulo',this.OpcionPropuesta.ColorTextoTitulo);
			formData.set('TerminosA',this.OpcionPropuesta.TerminosA);
			formData.set('TerminosB',this.OpcionPropuesta.TerminosB);
			formData.set('TerminosC',this.OpcionPropuesta.TerminosC);
			formData.set('NombreFoto',this.OpcionPropuesta.Imagen);
			formData.set('NombreFotoOficina',this.OpcionPropuesta.ImagenOficina);
			formData.set('TipoImpuesto',this.OpcionPropuesta.TipoImpuesto);
			formData.set('FuenteTitulo',this.OpcionPropuesta.FuenteTitulo);
			formData.set('FuenteCuerpo',this.OpcionPropuesta.FuenteCuerpo);
			formData.set('CartaPresentacion',this.OpcionPropuesta.CartaPresentacion);
			formData.set('DescripcionOficina',this.OpcionPropuesta.DescripcionOficina);
			formData.set('PiePagina',this.OpcionPropuesta.PiePagina);
			formData.set('PaginaWeb',this.OpcionPropuesta.PaginaWeb);
			let file = this.$refs.file.files[0];
			formData.append("File", file);
			let fileoficina = this.$refs.fileoficina.files[0];
			formData.append("FileOficina", fileoficina);
			// formData.set('Color',this.OpcionPropuesta.Color);
			await this.$http.post('opcionespropuesta/post',formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res)=>{
				this.$toast.success('Información Guardada');
				this.DisabledBtn=false;
                this.Recuperar();
			}).catch( err => {
                this.$toast.error('Agregue todos los campos');
				this.DisabledBtn=false;
            });
		},
		Limpiar(){
			this.OpcionPropuesta={
				IdOpcionPropuesta:0,
				Color:"#000000",
				ColorTexto:"#000000",
				ColorTextoTitulo:"#000000",
				TerminosA:"",
				TerminosB:"",
				TerminosC:"",
				TipoImpuesto:"",
				FuenteTitulo:"",
				FuenteCuerpo:"",
				CartaPresentacion:"",
				ImagenOficina:"",
				DescripcionOficina:"",
				PiePagina:"",
				PaginaWeb:""
			},
			this.Img="",
			this.ImgOficina="",
			this.readURL(this.Img);
			this.readURLOficina(this.ImgOficina);
		},
		Regresar(){
			this.$router.push({name:'submenucotizacion'});
		},
		async Recuperar(){
			await this.$http.get('opcionespropuesta/get').then((res)=>{
				// this.$toast.success('Configuración Guardada Correctamente');
				if (res.data.message!='Sin Resultado.') {
					this.OpcionPropuesta=res.data.data.opcionpropuesta;	
					let Fot2gn = res.data.data.opcionpropuesta.Imagen;
					if (Fot2gn != "" && Fot2gn != null) {
						this.Img = res.data.data.UrlFoto + this.OpcionPropuesta.Imagen;
						this.readURL(this.Img);
					}
					else{
						this.Img = this.RutaEmpresa + this.LogoEmpresa;
						this.readURL(this.Img);
					}

					let FotoOficina = res.data.data.opcionpropuesta.ImagenOficina;
					if (FotoOficina != "" && FotoOficina != null) {
						this.ImgOficina = res.data.data.UrlFotoOficina + this.OpcionPropuesta.ImagenOficina;
						this.readURLOficina(this.ImgOficina);
					}
					else{
						this.ImgOficina = this.RutaEmpresa + this.LogoEmpresa;
						this.readURLOficina(this.ImgOficina);
					}
				}
				else{
					this.Img = this.RutaEmpresa + this.LogoEmpresa;
					this.readURL(this.Img);
				}
				this.ConfigLoad.ShowLoader=false;
			});
		},
		uploadImage() {
			this.OpcionPropuesta.Imagen = this.$refs.file.files[0];
			const image = this.$refs.file.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Img = e.target.result;
				this.readURL(this.Img);
			};
		},
		uploadImageOficina() {
			this.OpcionPropuesta.ImagenOficina = this.$refs.fileoficina.files[0];
			const image = this.$refs.fileoficina.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.ImgOficina = e.target.result;
				this.readURLOficina(this.ImgOficina);
			};
		},
		readURL(input) {
			$$("#imagePreview").css("background-image", "url(" + this.Img + ")");
			$$("#imagePreview").hide();
			$$("#imagePreview").fadeIn(650);
		},
		readURLOficina(input) {
			$$("#imagePreviewOficina").css("background-image", "url(" + this.ImgOficina + ")");
			$$("#imagePreviewOficina").hide();
			$$("#imagePreviewOficina").fadeIn(650);
		},
	},
	created() {
		this.Limpiar();
		this.Recuperar();
		this.RutaEmpresa=sessionStorage.getItem("rutaE");
		this.LogoEmpresa=JSON.parse(sessionStorage.getItem("empresa")).Logo;
	},
}
</script>

<style>

</style>
